import { MixAndMatchPriceCoupon } from "./mix-and-match-price";
import { FirstMatchGroupItemTriggerItemsQualifier } from "../../coupon-qualifiers/trigger-items/first-match-group-item-trigger-items";
/**
 * QUANTITY_PRICE (coupon type 50).
 *
 * Modeled on AOLO3 (`coupons.ts`), where QUANTITY_PRICE shares the mix-and-match *price*
 * discount math (`_getDiscountAmountForQuantityPriceCoupon` and the
 * `_calculateQuantityOrMixMatchSplit` before-tax split) but NOT the mix-and-match
 * qualification path:
 *
 *   - `_getQualifiedItemList` routes MIX_AND_MATCH_* through a repeated
 *     `QualifyCouponItems(..., qualifyAnyQTY: true)` sweep plus a MinimumItemQuantity gate.
 *   - QUANTITY_PRICE falls through to the generic `coupon.Items.length > 0` case, which runs
 *     a single `QualifyCouponItems(order, coupon, false, false, true)` pass. The `--i`
 *     re-qualify loop inside `_qualifyCouponItemsGroupQTY` is gated on the coupon type being
 *     MIX_AND_MATCH_*, so type 50 never sweeps up extra matches, and no min-qty check runs.
 *
 * Hence: inherit the price math/distributor, swap in the single-pass first-match trigger
 * search, and opt out of the minimum-quantity gate.
 */
export class QuantityPriceCoupon extends MixAndMatchPriceCoupon {
    createTriggerItemsQualifier() {
        return new FirstMatchGroupItemTriggerItemsQualifier(this._data);
    }
    get enforcesMinimumQuantity() {
        return false;
    }
}
//# sourceMappingURL=quantity-price.js.map